'use strict';

angular.module('theme').service('PointsService', function ($q, $http, $cacheFactory) {

	// Cache the request
	var requestCache;
	var httpCache = $cacheFactory.get('$http');

	this.get = function () {
		// Return the cached promise if there is one
		if (requestCache) {
			return requestCache;
		}

		requestCache = $http({
			url: '/backapi/customer',
			method: 'GET',
			cache: true
		}).then(function (response) {
			return response.data.loyaltyPoints || 0;
		});

		return requestCache;
	};

	this.order = function (points, description, delivery) {
		return $http({
			url: '/backapi/points',
			method: 'POST',
			data: {
				points: points,
				description: description,
				sendHowTo: delivery
			}
		}).then(function (response) {
			// If we have placed an order we need to reset the customer cache
			requestCache = undefined;
			httpCache.remove('/backapi/customer');

			return response.data;
		});
	};

});
